module.exports = __webpack_public_path__ + "static/img/kong_qx.cc8da0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/zxyl/kong_qx.png
// module id = e/UJ
// module chunks = 2